import { absolutePath } from "./absolutePath";

export const connectSettings = {
  index: ({ params = {} } = {}) =>
    absolutePath("admin/connect/settings", params),
  update: ({ params = {} } = {}) =>
    absolutePath("admin/connect/settings", params),
};
